export { default } from './LayerImageControl';
